import React, { useState, useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import { connect } from 'react-redux'

import { getRelatedEntities } from '../redux/ContactActions'
import CustomNumberFormat from '../../ClickToCall/ClickToCall'
import Loader from '../../Loader/BasicLoader'
import CustomPrimeTable, { DEFAULT_PAGE_SAZE } from '../../../common/PrimeTable/CustomPrimeTable'
import camelToSnake from '../../../utils/camelToSnake'
import { Link } from 'react-router-dom'
import { SHIPPERS } from '../../../constants/contactCategory'

const DEFAULT_PAGINATION = { limit: DEFAULT_PAGE_SAZE, first: 0 }

const RelatedEntities = ({ contact, getRelatedEntities, relatedEntities }) => {
  const [options, setOptions] = useState({
    pagination: DEFAULT_PAGINATION,
    sort: [],
    filter: [],
    tableFilter: [],
  })

  useEffect(() => {
    loadData()
  }, [options])

  const loadData = async () => {
    await getRelatedEntities(contact.id, options)
  }

  const onPageChange = async (event) => {
    const pagination = { limit: event.rows, first: event.first }
    let newOptions = { ...options, pagination }
    setOptions(newOptions)
  }

  const onFilterChange = async (event) => {
    let tableFilter = []

    Object.keys(event.filters).forEach(function (key) {
      tableFilter[camelToSnake(key)] = event.filters[key].value
    })

    let newOptions = {
      ...options,
      tableFilter,
      pagination: DEFAULT_PAGINATION,
    }
    setOptions(newOptions)
  }

  const onSortChange = async (event) => {
    let sort = []

    if (event.multiSortMeta) {
      event.multiSortMeta.map((row) => {
        sort[row.field] = row.order
      })
    }

    let newOptions = { ...options, sort }
    setOptions(newOptions)
  }

  let loader = null
  if (relatedEntities.isLoading) {
    loader = <Loader />
  }

  const nameBody = (rowData) => {
    let urlPrefix = 'contacts'
    if (rowData?.contactCategory === SHIPPERS) {
      urlPrefix = 'customer-logistics/all-customers'
    }

    return (
      <Link onClick={() => window.open(`/${urlPrefix}/${rowData.id}`)} rel='noopener noreferrer'>
        {rowData.name}
      </Link>
    )
  }

  const phoneColumn = (rowData) => {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <CustomNumberFormat
          className={'form-control-sm form-control'}
          name='office_phone'
          value={rowData.businessPhone || ''}
          placeholder='Office Phone'
          type='tel'
          disabled
          format='(999) 999-9999'
          size={10}
          contactId={rowData.id}
        />
      </div>
    )
  }

  const columns = [
    {
      field: 'name',
      header: 'Name',
      body: nameBody,
    },
    {
      field: 'ownerName',
      header: 'Company Owner',
    },
    {
      field: 'addressCity',
      header: 'Address',
    },
    {
      field: 'email',
      header: 'Email',
    },
    {
      field: 'businessPhone',
      header: 'Office Phone',
      body: phoneColumn,
    },
  ]

  return (
    <Fragment>
      <Row style={{ marginTop: '-20px' }}>
        <Col>
          {loader}
          <CustomPrimeTable
            addHidden
            showActions={false}
            data={relatedEntities.data}
            columns={columns}
            onPage={onPageChange}
            onSort={onSortChange}
            onFilter={onFilterChange}
            query={relatedEntities.query}
            findHidden={true}
          />
        </Col>
      </Row>
    </Fragment>
  )
}

RelatedEntities.propTypes = {
  contactId: PropTypes.object.isRequired,
  getRelatedEntities: PropTypes.func.isRequired,
  relatedEntities: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  relatedEntities: state.contacts.relatedEntities,
})

export default connect(mapStateToProps, { getRelatedEntities })(RelatedEntities)
